export enum TracciatoOverwriteModes {
  append = 0,
  overwrite = 1,
  wait = 2
}

export const TRACCIATO_OVERWRITE_MODES = [
  { value: TracciatoOverwriteModes.append, label: 'Accoda' },
  { value: TracciatoOverwriteModes.overwrite, label: 'Sovvrascrivi' },
  { value: TracciatoOverwriteModes.wait, label: 'Attendi file non presente' }
];
